import { render, staticRenderFns } from "./DefinitionTitle.vue?vue&type=template&id=2422edbe&scoped=true&"
import script from "./DefinitionTitle.vue?vue&type=script&lang=ts&"
export * from "./DefinitionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionTitle.vue?vue&type=style&index=0&id=2422edbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2422edbe",
  null
  
)

export default component.exports